import React from 'react';
import { connect } from 'react-redux';

import { goTo } from '../tools';
import { desbloquearUsuario, cargarPreguntas } from './services.act';
import ModalCambiarPreguntas from '../miPerfil/modalCambiarPreguntas.cmpt.js';

const mapState = (state) => {
    return {
        secreto: state.login.secreto,
        pUno: state.login.pUno,
        pUnoText: state.login.pUnoText,
        pDos: state.login.pDos,
        pDosText: state.login.pDosText,
        preguntas1: state.catalogos.objetoPregunta1,
		preguntas2: state.catalogos.objetoPregunta2,
		correo: state.login.correo,
		uid: state.login.uid
    };
}
const mapDispatch = (dispatch) => {
    return {
        cargarPreguntas: (correo) => {
            dispatch(cargarPreguntas(correo))
        },
        desbloquearUsuario: (datos) => {
            dispatch(desbloquearUsuario(datos))
        },
        pasoSiguiente: () => {
            dispatch({ "type": "LOGIN_PASO_SIGUIENTE" });
        },
        resetPasos: () => {
            dispatch({ "type": "LOGIN_RESET_PASO"});
        },
        addEvento: (evento) => {
			dispatch({ "type": "LOGIN_SET_EVENT", "evento": evento});
		}
    }
}

class Preguntas extends React.Component {
    state = {
        intentoPregunta: 1,
        preguntaActual: this.props.pUnoText,
        preguntaActualId: this.props.pUno,
        inputRespuestaType: "password",
        inputRespuestaType2: "password",
        inputClass: "input-wrap ver-input",
        inputClass2: "input-wrap ver-input",
        inputActive: "",
        inputActive2: "",
        error: false,
        errorMsj: "",
        error2: false,
        errorMsj2: "",
        respuestaActual: "",
        bloqueado: false
    }
    handleBlur = (event) => {
        let id = event.target.id;
        let valor = event.target.value;
        switch(id) {
        	case "inputPreguntaPass":
                this.setState({inputActive: valor ? "input-active" : ""});
                break;
            case "inputPreguntaPass2":
                this.setState({inputActive2: valor ? "input-active" : ""});
                break;
        }
    }
    handleFocus = (event) => {
        let id = event.target.id;
        this.setState({bloqueado: false});
        switch(id) {
        	case "inputPreguntaPass":
                this.setState({inputActive: "input-active"});
                this.setState({error: false});
                this.setState({errorMsj: ""});
                break;
            case "inputPreguntaPass2":
                this.setState({inputActive2: "input-active"});
                this.setState({error2: false});
                this.setState({errorMsj2: ""});
                break;
        }
    }
    changeInputType = (event) => {
        let id = event.target.id;
        let type;
        switch(id) {
        	case "ojoPreguntaPass":
                type = this.state.inputRespuestaType;
                this.setState({inputRespuestaType: type == "password" ? "text" : "password"});
                this.setState({inputClass: type == "password" ? "input-wrap visible-input" : "input-wrap ver-input"});
                break;
            case "ojoPreguntaPass2":
                type = this.state.inputRespuestaType2;
                this.setState({inputRespuestaType2: type == "password" ? "text" : "password"});
                this.setState({inputClass2: type == "password" ? "input-wrap visible-input" : "input-wrap ver-input"});
                break;
        }
    }
    checkPregunta = () => {
        if(!this.state.bloqueado) {
            this.setState({bloqueado: true});
            let p1 = this.props.pUno;
            let p2 = this.props.pDos;
            let r1 = this.refs.inputRespuesta.value;
            let r2 = this.refs.inputRespuesta2.value;
            if(!r1) {
                this.setState({errorMsj: "Campo requerido."});
                this.setState({error: true});
                this.props.addEvento("Campo vacío resp1 - PreguntasUsuarioBloqueado");
            }
            else if(!r2){
                this.setState({errorMsj2: "Campo requerido."});
                this.setState({error2:true});
                this.props.addEvento("Campo vacío resp2 - PreguntasUsuarioBloqueado");
            }
            else {
                let datos = {p1:p1,r1:r1,p2:p2,r2:r2,uid:this.props.uid, correo:this.props.correo}
                this.props.desbloquearUsuario(datos);
                
            
            /*
                verificarPregunta({p: p, r: r}).then((response) => response.json()).then((responseJson) => {
                    if(responseJson.success) {
                        window.location.href = '/#!/mi-perfil';
                    } else {
                        if(this.state.intentoPregunta == 1) {
                            $('#modal-error').modal('toggle');
                        } else {
                            this.props.pasoSiguiente();
                        }
                    }
                });*/
            }
        }

        
            // console.log("Nuevo proceso");
            // //validar preguntas secretas

            
             
        
    }
    siguientePregunta = () => {
        this.setState({intentoPregunta: this.state.intentoPregunta + 1});
        this.setState({preguntaActual: this.props.pDosText});
        this.setState({preguntaActualId: this.props.pDos});
        this.setState({respuestaActual: ""});
        this.refs.inputRespuesta.value = "";
        this.setState({bloqueado: false});
        $('#modal-error').modal('toggle');
    }
    terminar = () => {
        $('#modal-correcto').modal('toggle');
        this.props.resetPasos();
        goTo("login");
        //window.location.href = '/#!/login';
    }
    _handleKeyPress = (event) => {
        this.setState({error: false});
        this.setState({errorMsj: ""});
        if (event.key === 'Enter') {
            if(!this.state.bloqueado) {
                this.setState({bloqueado: true});
                let p = this.state.preguntaActualId;
                let r = event.target.value;
                if(!r) {
                    this.setState({errorMsj: "Campo requerido."});
                    this.setState({error: true});
                } else {
                    this.checkPregunta();
                }
            }
        }
    }
    
    componentWillMount = () => {
        let $this = this;
        $this.props.cargarPreguntas(this.props.correo);
    }

    render() {
        return <div className="login-form">
            <div className="modal fade modal-msj" id="modal-editar-preguntas" tabIndex="-1" role="dialog" aria-labelledby="modal-editar-preguntasLabel" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <ModalCambiarPreguntas />
                    </div>
                </div>
            </div>
            <div className="text-content mt-10">
                <div className="datos-wrap row">
                    <div className="col-xs-12">
                        <h5>Preguntas Secretas 
                        </h5>
                    </div>
                    <div className="col-xs-12">
                        <div className="row mt-10">
                            <div className="col-xs-12">
                                <div className="input-wrap">
                                    <label>Pregunta 1</label>
                                    <p>{this.props.preguntas1[this.props.pUno]}</p>
                                </div>
                            </div>
                            <div className="col-xs-12">
                                <div className={this.state.inputClass}>
                                    <label>Respuesta</label>
                                    <span className="input-active">
                                        <input id="inputPreguntaPass" ref="inputRespuesta" type={this.state.inputRespuestaType} onBlur={this.handleBlur} onFocus={this.handleFocus} onKeyPress={this._handleKeyPress} />
                                        <button id="ojoPreguntaPass" className="btn-ojo" onClick={this.changeInputType}></button>
                                    </span>
                                    { this.state.error && 
                                        <div className="error-wrap">
                                            <div className="msj-error">
                                                {this.state.errorMsj}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            
                            <div className="col-xs-12">
                                <div className="input-wrap">
                                    <label>Pregunta 2</label>
                                    <p>{this.props.preguntas2[this.props.pDos]}</p>
                                </div>
                            </div>
                            <div className="col-xs-12">
                                <div className={this.state.inputClass2}>
                                    <label>Respuesta</label>
                                    <span className="input-active">
                                        <input id="inputPreguntaPass2" ref="inputRespuesta2" type={this.state.inputRespuestaType2} onBlur={this.handleBlur} onFocus={this.handleFocus} onKeyPress={this._handleKeyPress} />
                                        <button id="ojoPreguntaPass2" className="btn-ojo" onClick={this.changeInputType}></button>
                                    </span>
                                    { this.state.error2 && 
                                        <div className="error-wrap">
                                            <div className="msj-error">
                                                {this.state.errorMsj2}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button disabled={this.state.bloqueado} onClick={this.checkPregunta} className="orange-rectangle">Desbloquear</button>
                <div className="col-xs-12">
                    <div className="modal-body text-center">
                        <p>¿No recuerdas tus preguntas secretas? <a className="naranja-normal" data-toggle="modal" data-target="#modal-editar-preguntas">Reestablecer preguntas secretas</a></p>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="modal-error" tabIndex="-1" role="dialog" aria-labelledby="modal-errorLabel" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title txt-orange" id="modal-errorLabel">Lo sentimos</h4>
                        </div>
                        <div className="modal-body text-center">
                            <p>La respuesta que ingresaste no es correcta.</p>
                            <p>Reponde la siguiente pregunta.</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn orange-btn" onClick={this.siguientePregunta}>Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal modal-msj fade" id="modal-correcto" tabIndex="-1" role="dialog" aria-labelledby="modal-correctoLabel" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div>
                            <h5 className="text-center" id="modal-correctoLabel">Usuario desbloqueado</h5>
                        </div>
                        <div className="txt-black">
                            <p>Tu usuario ha sido desbloqueado</p>
                            <p>Se le ha mandado un correo para que pueda resetear sus datos y poder ingresar al Portal.</p>
                        </div>
                        <div className="text-center aceptar-cancelar-btn mt-20">
                            <button type="button" className="btn orange-btn" onClick={this.terminar}>Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default connect(mapState, mapDispatch)(Preguntas);


// WEBPACK FOOTER //
// ./src/gnp-login/preguntas.cmpt.js